module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p5"
  }, [_vm._v("Thank you to Donna, Kelly, Stella,")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("and everyone else in my beta group")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("who helped me with both this book")]), _vm._v(" "), _c('p', {
    staticClass: "p0"
  }, [_vm._v("and the logic of this whole universe.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47b56e64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/004.vue
// module id = 63
// module chunks = 0